<template>
  <div id="calendar">
    <v-row no-gutters>
      <v-col cols="2">
        <v-btn icon @click="preDay" class="mt-4">
          <v-icon dark>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="8">
        <v-menu
          v-model="picker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              placeholder="조회할 날짜를 선택하세요"
              prepend-inner-icon="mdi-calendar"
              class="date-field"
              readonly
              v-bind="attrs"
              v-on="on"
              :value="showDate"
            ></v-text-field>
          </template>
          <v-date-picker v-model="selectedDate" no-title @input="picker = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-btn icon @click="nextDay" class="mt-4">
          <v-icon dark> mdi-arrow-right-thick </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    returnFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
  },
  data() {
    return {
      selectedDate: null,
      picker: false,
    }
  },
  created() {
    // 현재 날짜를 선택한다.
    this.selectedDate = this.$moment().format('YYYY-MM-DD')
  },
  computed: {
    showDate() {
      return this.$moment(this.selectedDate).format('YYYY-MM-DD (ddd)')
    },
  },
  watch: {
    selectedDate(newValue) {
      this.$emit('emitChangedDate', newValue)
    },
  },
  methods: {
    convert(date) {
      // date 는 moment 를 넘긴다
      return date.format(this.returnFormat)
    },
    preDay() {
      const temp = this.$moment(this.selectedDate).add(-1, 'days')
      this.selectedDate = this.convert(temp)
    },
    nextDay() {
      const temp = this.$moment(this.selectedDate).add(+1, 'days')
      this.selectedDate = this.convert(temp)
    },
  },
}
</script>

<style lang="scss" scoped>
#calendar {
  text-align: center;

  .date-field {
    max-width: 290px;
    margin: 0 auto;
  }

  :deep(.v-text-field__slot) {
    input {
      text-align: center;
    }
  }
}
</style>
